export const translations = {
	'Events for asset {0}': {
		no: 'Hendelser for ressurs {0}',
	},
	'All events for monitor': {
		no: 'Alle hendelser for monnitor',
	},
};
